export default function ({ store, $axios }, inject) {
  // Create a custom axios instance
  const axiosV2 = $axios.create({
    headers: {
      common: {
        Accept: 'application/json, text/plain, */*'
      }
    }
  });

  axiosV2.onRequest((config) => {
    if (config.headers.common) {
      let authCookie = '';

      if (process.server) {
        authCookie =
          getAppCookies(config)['vx.token.local'] ||
          getAppCookies(config)['vx.token.google'] ||
          getAppCookies(config)['vx.token.facebook'];
      } else {
        authCookie =
          store.$cookies.get('vx.token.local') ||
          store.$cookies.get('vx.token.google') ||
          store.$cookies.get('vx.token.facebook');
      }
      if (authCookie) {
        config.headers.common['Authorization'] = authCookie;
      }
    }
  });

  axiosV2.onError((error) => {
    const code = parseInt(error.response && error.response.status);
    if (code === 401) {
      const domain = process.env.COOKIES_DOMAIN;
      const path = '/';
      store.$cookies.remove('vx.strategy', { domain, path });
      store.$cookies.remove('vx.token.local', { domain, path });
      store.$cookies.remove('vx.token.google', { domain, path });
      store.$cookies.remove('vx.token.facebook', { domain, path });
      store.dispatch('auth/logout');
    }
  });

  axiosV2.setBaseURL(process.env.API_URL_V2);

  // Inject to context as $axiosV2
  inject('axiosV2', axiosV2);
}

const getAppCookies = (req) => {
  const rawCookies = req.headers.common.cookie ? req.headers.common.cookie.split('; ') : [];
  const parsedCookies = {};
  rawCookies.forEach((rawCookie) => {
    const parsedCookie = rawCookie.split('=');
    parsedCookies[parsedCookie[0]] = parsedCookie[1];
  });

  return parsedCookies;
};
